var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import SearchBar from "@frameworks/web/components/generic/SearchBar";
import ClientSearch from "@frameworks/salesjourney/components/Generic/ClientSearch";
import { debounce } from "@frameworks/salesjourney/utils/genericMethods";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { accountDetails } from "@mainDi/salesDi";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/shared-library/components/ErrorNotification";
import { generateClientTierIcon } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import RecentSearchPopup from "@frameworks/shared-library/components/Search/RecentSearchPopup";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { useNavigate } from "react-router-dom";
/**
 * MFPlaceOrderClientNameColumn
 *
 * This component is used on Place order screen to display client details column
 *
 * @param {any} clientDetails - client details
 * @param {string} transactionId - specific row's unique Id
 * @param {string} targetTransactionId - actioned row's transaction Id
 * @param {Function} setTransactionId - set current transaction Id
 * @param {Function} setSearchClientPopup - Function show or hide scheme search popup
 * @param {boolean} searchClientPopup - show or hide scheme search popup
 * @param {Function} callbackDisplayConfirmationPopup - call back function to show or hide confirmation popup
 * @param {Function} callbackHandleClientSearchSelection - call back function to set selected client details
 * @returns {}
 */
var MFPlaceOrderClientNameColumn = function (_a) {
    var _b, _c;
    var clientDetails = _a.clientDetails, transactionId = _a.transactionId, targetTransactionId = _a.targetTransactionId, setTransactionId = _a.setTransactionId, searchClientPopup = _a.searchClientPopup, setSearchClientPopup = _a.setSearchClientPopup, callbackDisplayConfirmationPopup = _a.callbackDisplayConfirmationPopup, callbackHandleClientSearchSelection = _a.callbackHandleClientSearchSelection, customeIcon = _a.customeIcon, hideClientSearchRightContent = _a.hideClientSearchRightContent, searchInputPlaceholder = _a.searchInputPlaceholder, showSearchCount = _a.showSearchCount, showNameAsLink = _a.showNameAsLink;
    var _d = __read(useState(""), 2), clientSearchText = _d[0], setClientSearchText = _d[1];
    var _e = __read(useState(false), 2), clientSearchLoader = _e[0], setClientSearchLoader = _e[1];
    var _f = __read(useState([]), 2), clientSearchDataState = _f[0], setClientSearchDataState = _f[1];
    var _g = __read(useState(null), 2), clientSearchError = _g[0], setClientSearchError = _g[1];
    var _h = __read(useState(false), 2), isSearchFocused = _h[0], setIsSearchFocused = _h[1];
    var _j = __read(useState(null), 2), fullClientDetails = _j[0], setFullClientDetails = _j[1];
    var _k = __read(useState([]), 2), recentSearchesData = _k[0], setRecentSearchesData = _k[1];
    var hasFetchedRecentSearches = useRef(false);
    var searchPopUpRef = useRef(null);
    var clientSearchContainerRef = useRef(null);
    var navigate = useNavigate();
    var saveRecentSearch = function (selectedClientData) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, clientDi.clients.recentClientSearchSave(selectedClientData)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.log("err", err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOnChangeClientSearch = function (e, trxId) {
        setTransactionId(trxId);
        setClientSearchText(e);
        if (e) {
            var inputValue_1 = e;
            if (inputValue_1.length < 3) {
                setClientSearchDataState([]);
                setClientSearchError(null);
                setSearchClientPopup(false);
                return;
            }
            setClientSearchLoader(true);
            setSearchClientPopup(true);
            debounce(function () { return getClientSearchData(inputValue_1); });
            hasFetchedRecentSearches.current = false;
        }
    };
    var getClientSearchData = function (searchText) { return __awaiter(void 0, void 0, void 0, function () {
        var loginCode, userType, loginType, getClientForSelectedRMPayload, clientsUnderSelectedRM, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 1:
                    loginCode = _a.sent();
                    userType = "";
                    loginType = localStorage.getItem(ELocalStorageKeys.LoginType);
                    switch (loginType) {
                        case ILoginTypeEnum.RM:
                            userType = "Employee";
                            break;
                        case ILoginTypeEnum.FRM:
                            userType = "Employee";
                            break;
                        case ILoginTypeEnum.PARTNER:
                            userType = "Partner";
                            break;
                        default:
                            break;
                    }
                    getClientForSelectedRMPayload = {
                        userType: userType,
                        userId: loginCode,
                        searchText: searchText,
                        page: "1",
                        pageSize: "100",
                    };
                    setClientSearchError(null);
                    return [4 /*yield*/, clientDi.clients.searchClientsByRmWithOwnClient(getClientForSelectedRMPayload)];
                case 2:
                    clientsUnderSelectedRM = _a.sent();
                    setClientSearchDataState(clientsUnderSelectedRM);
                    setClientSearchLoader(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log("err", error_1);
                    setClientSearchError({ isOpen: true, error: error_1 });
                    setClientSearchLoader(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleClickOutside = function (event) {
        if (searchPopUpRef.current &&
            !searchPopUpRef.current.contains(event.target)) {
            setSearchClientPopup(false); // Close the component if clicked outside
            setClientSearchText("");
            setTransactionId("");
            setIsSearchFocused(false);
            hasFetchedRecentSearches.current = false;
        }
    };
    var handleOnFocus = function () {
        setIsSearchFocused(true);
        if (!hasFetchedRecentSearches.current) {
            getRecentSearches();
            hasFetchedRecentSearches.current = true;
        }
    };
    var handleSelectFromRecentSearch = function (selectedItem) {
        setClientSearchText(selectedItem.search_txt);
        saveRecentSearch({
            categoryCode: ESubProductIds.MutualFund,
            uccCode: selectedItem.uccCode,
            searchText: selectedItem.search_txt,
        });
    };
    var getRecentSearches = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, clientDi.clients.recentClientSearchGet({
                            categoryCode: ESubProductIds.MutualFund,
                        })];
                case 1:
                    resp = _a.sent();
                    setRecentSearchesData(resp);
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.log("err", err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClientNameClick = function () {
        clientDi.partnerOverview.clearALLStoreData();
        clientDi.clients.setSelectedClientOnSearchClick(fullClientDetails);
        navigate("/clientdetails/overview?link=overview");
    };
    useEffect(function () {
        // Add event listener for clicks outside the element
        var searchDiv = document.getElementById("client-search-popup");
        searchDiv && searchDiv.addEventListener("click", handleClickOutside);
        // Cleanup the event listener on component unmount
        return function () {
            searchDiv && searchDiv.removeEventListener("click", handleClickOutside);
        };
    }, []);
    useLayoutEffect(function () {
        var checkZoom = function () {
            var _a, _b;
            var zoomRatio = window.outerWidth / window.innerWidth;
            var isZoom100OrMore = zoomRatio >= 1;
            if (clientSearchContainerRef === null || clientSearchContainerRef === void 0 ? void 0 : clientSearchContainerRef.current) {
                if (isZoom100OrMore) {
                    clientSearchContainerRef.current.classList.add("reducedWidth");
                    if (clientSearchDataState.length > 0) {
                        (_a = searchPopUpRef === null || searchPopUpRef === void 0 ? void 0 : searchPopUpRef.current) === null || _a === void 0 ? void 0 : _a.classList.add("zoomed__client__search__popup");
                    }
                }
                else {
                    clientSearchContainerRef === null || clientSearchContainerRef === void 0 ? void 0 : clientSearchContainerRef.current.classList.remove("reducedWidth");
                    (_b = searchPopUpRef === null || searchPopUpRef === void 0 ? void 0 : searchPopUpRef.current) === null || _b === void 0 ? void 0 : _b.classList.remove("zoomed__client__search__popup");
                }
            }
        };
        // Delay initial check slightly
        var timeoutId = setTimeout(checkZoom, 50);
        window.addEventListener("resize", checkZoom);
        return function () {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", checkZoom);
        };
    }, [clientSearchDataState]);
    return clientDetails ? (React.createElement("div", { className: "d-flex flex-row client-name-container" },
        React.createElement(GenericSchemeName, __assign({ name: clientDetails.clientName, subText1: clientDetails.uniqueClientId, subText2: clientDetails.pan, maxWidth: 235, parentClassName: "place-order-client-name ".concat((_b = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clientTier) === null || _b === void 0 ? void 0 : _b.toLowerCase()), badgeIcon: generateClientTierIcon(clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clientTier), showTooltip: true, showImage: true }, (showNameAsLink && {
            clickHandlerConfig: {
                schemeNameClickConfig: {
                    className: "show-as-link",
                    onClickHandler: handleClientNameClick,
                },
            },
        }))),
        customeIcon ? (customeIcon) : (React.createElement(Edelicon, { className: "edel-icon-withoutcolor-cross", paths: 2, onClick: function () {
                callbackDisplayConfirmationPopup("removeClient" /* EPlaceOrderActions.REMOVE_CLIENT */, [
                    transactionId,
                ]);
                setClientSearchText("");
            } })))) : (React.createElement("div", { ref: clientSearchContainerRef, className: "client-search-container" },
        React.createElement(SearchBar, { parentClassName: "fund-search client-name-search", searchIcon: "edel-icon-search txt-midnight-blue", onCallbackFunction: function (e) {
                return handleOnChangeClientSearch(e, transactionId);
            }, onClose: function () {
                setClientSearchText("");
                setTransactionId("");
            }, deskPlaceHolder: searchInputPlaceholder !== null && searchInputPlaceholder !== void 0 ? searchInputPlaceholder : "Search Client", searchBarBackground: "search-text bg_white DMSans_13_400", openInputBackground: "search-text bg_white DMSans_13_400", showBackArrow: false, closeIcon: "edel-icon-bold-close", autoComplete: "off", onFocus: handleOnFocus, searchKey: clientSearchText }),
        isSearchFocused &&
            !clientSearchText &&
            recentSearchesData.length > 0 && (React.createElement("div", { className: "px-0 position-absolute bg_white client-search-popup header w-100 d-flex flex-column align-items-center justify-content-center ".concat(clientSearchLoader ? "client-search-popup-loader-container" : "") },
            React.createElement(RecentSearchPopup, { searches: recentSearchesData, onSelect: handleSelectFromRecentSearch }))),
        searchClientPopup &&
            clientSearchText !== "" &&
            Boolean(transactionId) &&
            targetTransactionId === transactionId && (React.createElement("div", { ref: searchPopUpRef, id: "client-search-popup", className: "px-0 position-absolute bg_white client-search-popup header w-100 d-flex flex-column align-items-center justify-content-center ".concat(clientSearchLoader ? "client-search-popup-loader-container" : "") }, (clientSearchError === null || clientSearchError === void 0 ? void 0 : clientSearchError.error) && (clientSearchError === null || clientSearchError === void 0 ? void 0 : clientSearchError.isOpen) ? (React.createElement(ErrorNotification, { error: clientSearchError === null || clientSearchError === void 0 ? void 0 : clientSearchError.error, isOpen: clientSearchError === null || clientSearchError === void 0 ? void 0 : clientSearchError.isOpen, displayType: ErrorDisplayType.INSECTION })) : (React.createElement("div", { className: "w-100" },
            ((_c = clientSearchDataState === null || clientSearchDataState === void 0 ? void 0 : clientSearchDataState[0]) === null || _c === void 0 ? void 0 : _c.ispansearch) === "true" && (React.createElement("div", null,
                React.createElement("label", { className: "d-flex align-items-center gap-2 DMSan_14_500 px-3" }, "Client Match Found"))),
            React.createElement(ClientSearch, { clientSearchList: clientSearchDataState, searchText: clientSearchText, loader: clientSearchLoader, setCallbackFunction: function (data) {
                    setFullClientDetails(data);
                    callbackHandleClientSearchSelection(data);
                    saveRecentSearch({
                        searchText: clientSearchText,
                        uccCode: data.ucccode,
                        categoryCode: ESubProductIds.MutualFund,
                    });
                }, hideClientSearchRightContent: hideClientSearchRightContent, showSearchCount: showSearchCount })))))));
};
export default MFPlaceOrderClientNameColumn;
